export default __webpack_public_path__ + "static/media/Self Reflection 2018 -- Pastel on Paper -- 19in x 24in.bc0a079c.jpg";